export const SSO_IDENTITY_LOGIN_PATH = '/ssoidentity/Login';
export const SSO_IDENTITY_AD_LOGIN_PATH = `${SSO_IDENTITY_LOGIN_PATH}?ssoLoginType=ActiveDirectory`;
export const AD_LOGIN_PATH = '/system/UI/SsoLogin/LoginWithExternalProvider?externalProviderType=ActiveDirectory';
